import * as React from "react";
import Modal, { ModalSize } from "../../misc/components/modal";
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { AsyncActionButton } from "../components/AsyncActionButton";

export interface DisplayProgressProps {
    when: any;
    currentProgress: number;
    onCancel: () => void;
}

const formatPercent = (progress: number) => `Uploading - ${progress}%`;

export const UploadProgressDialog = (props: DisplayProgressProps) => {
    const { when, currentProgress, onCancel } = props;

    return (<Modal zIndex={ 5000 } show={when} size={ModalSize.Small} header="Processing File Upload">
        <div className="modal-body text-center">
            <div style={{ width: 150, height: 150, display: 'inline-block' }}>
                <CircularProgressbarWithChildren
                    value={currentProgress}
                    maxValue={100}
                    styles={buildStyles({
                        pathColor: `#00aeff`,
                        pathTransitionDuration: 1,
                        textSize: '12px',
                    })}>
                    <p className="text-center">{formatPercent(currentProgress)}</p>
                </CircularProgressbarWithChildren>
            </div>        
            </div>
            <div className="modal-footer">
                <AsyncActionButton className="btn btn-danger" type="submit" isSubmitting={false} onClick={onCancel}>
                    Cancel
                </AsyncActionButton>
            </div>
    </Modal>);
}
